import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-two',
  templateUrl: './title-two.component.html',
  styleUrls: ['./title-two.component.scss'],
})
export class TitleTwoComponent implements OnInit {
  @Input() title: string;

  constructor() {}

  ngOnInit() {}
}
